import { DCUIContent } from '@iddataweb/idw-common-ui/types';
import styles from "./dcui-theming-error-page.less";

type DCUIThemingErrorPageProps = {
    dcuiContent: DCUIContent;
};

export const DCUIThemingErrorPage = (props: DCUIThemingErrorPageProps) => {
    const { dcuiContent } = props;

    return (
        <div className={styles.dcuiThemingErrorPage}>
            <h4>{dcuiContent.error.header}</h4>
            <span>{dcuiContent.error.message}</span>
            <span>{dcuiContent.error.transactionId}: xxxx-xxxx-xxxx-xxxx</span>
        </div>
    );
};